import { ReportRepository } from "../../../../data/repository/report/ReportRepository";
import { DateRange } from "../../../model/Product";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetPerStoreReportUseCase {
  invoke: (dateRange?: DateRange) => Promise<ResponseState<Blob>>;
}

export class GetPerStoreReportUseCaseImpl implements GetPerStoreReportUseCase {
  private repository: ReportRepository;

  constructor(repository: ReportRepository) {
    this.repository = repository;
  }

  async invoke(dateRange?: DateRange): Promise<ResponseState<Blob>> {
    try {
      let response = await this.repository.getPerStore(dateRange);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
